"use strict";

require("core-js/modules/es.array.sort.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _createForOfIteratorHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createForOfIteratorHelper"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createSuper"));

var _react = _interopRequireDefault(require("react"));

require("./ChordBuilder.css");

var _abcjs = _interopRequireDefault(require("abcjs"));

var _MusicEditor = _interopRequireWildcard(require("./MusicEditor"));

var _AlertFeedback = _interopRequireDefault(require("../AlertFeedback"));

var _ModalFeedback = _interopRequireDefault(require("../ModalFeedback"));

var _CompletedContext = require("../CompletedContext");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
} // import axios from 'axios';


var ChordBuilder = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(ChordBuilder, _React$Component);

  var _super = (0, _createSuper2.default)(ChordBuilder);

  function ChordBuilder(props) {
    var _this;

    (0, _classCallCheck2.default)(this, ChordBuilder);
    _this = _super.call(this, props);

    _this.submitChord = function () {
      var parse = _abcjs.default.parseOnly(_this.precursor + _this.state.notation);

      var server_notation = "";

      if (parse[0].lines[0].staff[0].voices[0][0].pitches) {
        var clef = parse[0].lines[0].staff[0].clef.type;
        server_notation = parse[0].lines[0].staff[0].voices[0][0].pitches.map(function (note) {
          if (clef === "treble") {
            return (note.accidental ? _MusicEditor.accidentals[note.accidental] : "") + _MusicEditor.treble_pitches[note.pitch];
          } else if (clef === "bass") {
            return (note.accidental ? _MusicEditor.accidentals[note.accidental] : "") + _MusicEditor.bass_pitches[note.verticalPos];
          } else if (clef === "alto") {
            return (note.accidental ? _MusicEditor.accidentals[note.accidental] : "") + _MusicEditor.alto_pitches[note.verticalPos];
          }

          return "";
        });
        var correct = (0, _MusicEditor.serializeNotation)(_this.props.correct);

        var match = _this.arraysAreIdentical(server_notation.sort(), correct.sort());

        _this.setState({
          completed: true,
          correct: match
        });

        if (!match) {
          _this.setState({
            showFeedback: true
          });
        } // axios.post('https://smartwork5-stg2.wwnorton.com/services/eqt_response.php', request, config)
        // axios.post('https://digital.wwnorton.com/services/eqt_response.php', request, config)
        // .then(res=> {
        //   console.log(res)
        // 
        //   if(res.data.answer){
        //     this.setState({answer: serializeNotation(res.data.answer)});
        //   }
        //   this.setState({submission_number: res.data.submission_number, correct: res.data.correct, reset:false})
        // 
        //   if(this.local){
        //     let alertMsg =
        //     "Round: " + (parseInt(this.state.submission_number)-2)  + "\n" +
        //     "Chord: \"["+ server_notation.join('')+"]\"\n" +
        //     res.data.round_feedback;
        //     alert(alertMsg)
        //   }
        // 
        //   // document.getElementsByClassName(this.musiceditor.current.state.cursorPitch)[0].focus()
        // 
        //   window.parent.postMessage({ type: 'eqt_score',
        //     data: {"correct":res.data.correct,"feedback":res.data.round_feedback,"question_id":this.state.id}
        //     }, '*');
        // })

      }
    };

    _this.state = props.state || {};

    if (!_this.state.initialized) {
      _this.state.initialized = true; // Initial state is set here, since the constructor can be called more than once.

      _this.state.completed = false;
      _this.state.notation = _this.props.notation;
    }

    _this.extractMetadata = _this.extractMetadata.bind((0, _assertThisInitialized2.default)(_this));
    _this.musiceditor = /*#__PURE__*/_react.default.createRef();
    _this.token = (0, _MusicEditor.generateToken)();
    _this.metadata = {
      music_configuration: _this.props.precursor,
      //'X:1;L:1/4;M:;K:C;V:1 treble up',
      music_initial: _this.props.notation_intital,
      //"[]",
      music_button_note: "true",
      music_button_sharp: "true",
      music_button_flat: "true",
      music_button_natural: "false",
      music_button_double_sharp: "false",
      music_button_double_flat: "false",
      music_button_audio: "true",
      music_staff_width: "100%",
      music_duration: "2000",
      question_id: "5ec68c5d0fe26e12f7456892"
    };
    return _this;
  }

  (0, _createClass2.default)(ChordBuilder, [{
    key: "arraysAreIdentical",
    value: function arraysAreIdentical(arr1, arr2) {
      if (arr1.length !== arr2.length) return false;

      for (var i = 0, len = arr1.length; i < len; i++) {
        if (arr1[i] !== arr2[i]) {
          return false;
        }
      }

      return true;
    }
  }, {
    key: "checkIfNoteInNotation",
    value: function checkIfNoteInNotation(correctNote, notation) {
      var _this2 = this;

      var parsedResponse = _abcjs.default.parseOnly(this.precursor + notation);

      var t = 0;
      if (!parsedResponse[0].lines[0].staff[0].voices[0][0].pitches) return;
      parsedResponse[0].lines[0].staff[0].voices[0][0].pitches.forEach(function (notationNote) {
        if (_this2.arraysAreIdentical(Object.values(notationNote), Object.values(correctNote))) t++;
      });
      return t;
    }
  }, {
    key: "isTask",
    value: function isTask() {
      return true;
    }
  }, {
    key: "componentWillMount",
    value: function componentWillMount() {
      this.extractMetadata();
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this3 = this;

      console.log("task mount", this.state); // Notify the parent of our completion status

      this.context.registerTask(function (id) {
        _this3.setState({
          taskId: id
        });
      });
      this.context.onCompleted(this.state.completed, this.state.taskId);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevprops, prevstate, snapshot) {
      var _this4 = this;

      if (prevstate.completed !== this.state.completed || prevstate.taskId !== this.state.taskId) {
        // Make sure our parent knows about the completion
        this.context.onCompleted(this.state.completed, this.state.taskId);
      }

      for (var _i = 0, _Object$keys = Object.keys(this.state); _i < _Object$keys.length; _i++) {
        var key = _Object$keys[_i]; // Keep our stored state synchronized

        if (this.state[key] !== this.props.state[key]) {
          this.props.state[key] = this.state[key];
        }
      }

      if (this.state.submission_number > 2 && this.state.answer && !this.state.correct && !this.state.reset) {
        var parsedAnswer = _abcjs.default.parseOnly(this.precursor + this.state.answer.join(''));

        var _iterator = (0, _createForOfIteratorHelper2.default)(parsedAnswer[0].lines),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var line = _step.value;

            var _iterator2 = (0, _createForOfIteratorHelper2.default)(line.staff),
                _step2;

            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                var staff = _step2.value;

                var _iterator3 = (0, _createForOfIteratorHelper2.default)(staff.voices),
                    _step3;

                try {
                  for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                    var voice = _step3.value;

                    var _iterator4 = (0, _createForOfIteratorHelper2.default)(voice),
                        _step4;

                    try {
                      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                        var note = _step4.value;
                        var hotspot = document.getElementsByClassName(note.pitches[0].verticalPos)[0]; // capture snapshot of their round 3 input so that it only highlights the correct
                        // answer from their submission_number and not highlights as they click new notes

                        if (prevstate.submission_number !== this.state.submission_number) {
                          (function () {
                            //remove the incorrect options from the user submission_number (clear the incorrect answers)
                            var notationWithoutIncorrect = "";
                            var notationArray = (0, _MusicEditor.serializeNotation)(_this4.state.notation);

                            _this4.state.answer.forEach(function (correctNote) {
                              if (notationArray.includes(correctNote)) {
                                notationWithoutIncorrect += correctNote;
                              }
                            });

                            if (notationWithoutIncorrect === "") {
                              _this4.setState({
                                notation: 'z'
                              });
                            } else {
                              _this4.setState({
                                notation: '[' + notationWithoutIncorrect + ']'
                              });
                            }

                            if (_this4.state.submission_number === 3) {
                              // eslint-disable-next-line
                              _this4.state.notationRound3 = _this4.state.notation;

                              _this4.musiceditor.current.setState({
                                accidental: ""
                              });
                            }
                          })();
                        } // on round 3 we only highlight the hotspots over the notes are correct including accidental


                        if (this.checkIfNoteInNotation(note.pitches[0], this.state.notationRound3) && !this.state.correct) {
                          // && prevstate.submission_number != this.state.submission_number){
                          hotspot.classList.add('green');
                          hotspot.classList.remove('staff-space', 'staff-line');
                        } // on round 4 we highlight all hotspots and the correct corresponding accidental on hover


                        if (this.state.submission_number > 3 && !this.state.correct) {
                          hotspot.classList.add('green');
                          hotspot.classList.remove('staff-space', 'staff-line');

                          if (note.pitches[0].accidental) {
                            hotspot.correctAccidental = _MusicEditor.accidentals[note.pitches[0].accidental];
                          }
                        }
                      }
                    } catch (err) {
                      _iterator4.e(err);
                    } finally {
                      _iterator4.f();
                    }
                  }
                } catch (err) {
                  _iterator3.e(err);
                } finally {
                  _iterator3.f();
                }
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      } else {
        var numOfGreens = document.getElementsByClassName('green').length;

        for (var i = 0; i < numOfGreens; i++) {
          var _hotspot = document.getElementsByClassName('green')[0];

          _hotspot.classList.remove('green');

          _hotspot.classList.add('staff-space');

          _hotspot.style.fill = "#0000ff";
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      return /*#__PURE__*/_react.default.createElement("div", {
        className: "App"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "chord-builder-container",
        style: {
          width: this.metadata.music_staff_width
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "chord-builder",
        ref: this.ref
      }, this.state.completed && !this.state.correct && /*#__PURE__*/_react.default.createElement("p", {
        style: {
          padding: "10px",
          backgroundColor: "#f8d7da",
          borderRadius: "5px",
          border: "1px #f5c6cb solid"
        }
      }, "Your Submission:"), /*#__PURE__*/_react.default.createElement(_MusicEditor.default, {
        ref: this.musiceditor,
        addClasses: true,
        addHotspots: true,
        accidentals: true,
        chordMode: true,
        millisecondsPerMeasure: parseInt(this.metadata.music_duration),
        zoom: 4,
        metadata: this.metadata,
        precursor: this.precursor,
        notation: this.state.notation,
        answer: this.state.answer,
        onChange: function onChange(newNotation) {
          _this5.setState({
            notation: newNotation
          });
        },
        completed: this.state.completed
      })), !this.state.completed && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("button", {
        className: "action-button",
        disabled: this.state.correct,
        style: {
          float: "left"
        },
        onClick: function onClick() {
          var newNotation = _this5.metadata.music_initial;

          _this5.musiceditor.current.setState({
            accidental: ""
          });

          _this5.setState({
            notation: newNotation,
            reset: true
          });
        }
      }, " Reset "), /*#__PURE__*/_react.default.createElement("button", {
        className: "action-button",
        disabled: this.state.correct || this.state.notation.trim() === "z",
        style: {
          float: "right"
        },
        onClick: function onClick() {
          var newChord = _this5.state.notation.slice();

          _this5.setState({
            lastChordNotation: newChord
          });

          _this5.submitChord();
        }
      }, " Submit "))), this.state.completed && !this.state.correct && /*#__PURE__*/_react.default.createElement("div", {
        className: "scale-builder-container",
        style: {
          width: this.metadata.music_staff_width
        }
      }, /*#__PURE__*/_react.default.createElement("p", {
        style: {
          padding: "10px",
          backgroundColor: "#d4edda",
          borderRadius: "5px",
          border: "1px c3e6cb solid"
        }
      }, "Correct Answer:"), /*#__PURE__*/_react.default.createElement(_MusicEditor.default, {
        ref: this.musiceditor,
        addClasses: true,
        addHotspots: true,
        accidentals: true,
        chordMode: true,
        millisecondsPerMeasure: parseInt(this.metadata.music_duration),
        zoom: 4,
        metadata: this.metadata,
        precursor: this.precursor,
        notation: this.props.correct,
        answer: this.state.answer,
        onChange: function onChange(newNotation) {
          _this5.setState({
            notation: newNotation
          });
        },
        completed: this.state.completed
      })), /*#__PURE__*/_react.default.createElement(_ModalFeedback.default, {
        show: this.state.showFeedback && this.state.completed,
        onHide: function onHide() {
          _this5.setState({
            showFeedback: false
          });
        },
        buttonText: "Okay"
      }, "Incorrect. Please see the correct chord below your submission."), this.state.completed && this.state.correct && /*#__PURE__*/_react.default.createElement(_AlertFeedback.default, {
        feedback: 'Correct! You have submitted the right chord.'
      }));
    }
  }, {
    key: "extractMetadata",
    value: function extractMetadata() {
      var _this6 = this;

      var queryString = window.location.search.substring(1);

      if (queryString) {
        var metadata_in = JSON.parse(decodeURIComponent(queryString));
        Object.keys(metadata_in).forEach(function (key) {
          _this6.metadata[key] = metadata_in[key];
        });
      } else {
        this.local = true;
      }

      if (this.metadata.music_initial === "[]" || this.metadata.music_initial === "") this.metadata.music_initial = 'z';
      this.setState({
        id: this.metadata.question_id,
        notation: this.metadata.music_initial
      });
      this.precursor = this.metadata.music_configuration.replace('+', ' ');
      this.precursor = this.precursor.split(';').join('\n') + '\n';
    }
  }]);
  return ChordBuilder;
}(_react.default.Component);

ChordBuilder.contextType = _CompletedContext.CompletedContext;
var _default = ChordBuilder;
exports.default = _default;